export default __webpack_public_path__ + "static/callum-faris-cutout-6c052b879806ade7d308dd117962dd03.webp";